import React, { useState } from "react";
import CustomDialog from "../../../../global/components/CustomModal/CustomModal";
import MyProfileViewStyles from "./MyProfileView.styles";
import { Box, Grid, Step, StepLabel, Stepper, Typography } from "@mui/material";
import CustomButton from "../../../../global/components/CustomButton/CustomButton";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/close.svg";
import { ReactComponent as DownloadIcon } from "../../../../assets/icons/download.svg";
import { ReactComponent as PrintIcon } from "../../../../assets/icons/print.svg";
import AvtarImg from "../../../../assets/icons/avtar.svg";
import ViewPersonalinfomation from "../stepper/ViewPersonalinfomation/ViewPersonalinfomation";
import ViewOfficialInformation from "../stepper/ViewOfficialInformation/ViewOfficialInformation";
import ViewBankInformation from "../stepper/ViewBankInformation/ViewBankInformation";
import ViewEmployeeDocuments from "../stepper/ViewEmployeeDocuments/ViewEmployeeDocuments";
import ViewLeaveDetails from "../stepper/ViewLeaveDetails/ViewLeaveDetails";
import SalaryInformation from "../stepper/SalaryInformation/SalaryInformation";
const stepData = [
  "Personal Details",
  "Official Information",
  "Bank Information",
  "Employee Documents",
  "Leave Details",
  "Salary Information",
];

interface CustomProps {
  isDialogOpen: boolean;
  handleCloseProfile: Function;
}

const MyProfileView = (props: CustomProps) => {
  const classes = MyProfileViewStyles;
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState<{
    [k: number]: boolean;
  }>({});

  const totalSteps = () => {
    return stepData.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  // step 1 form validation method
  const handleStepOneValidation = () => {
    return true;
  };

  // go to next page method
  const nextStep = () => {
    if (handleStepOneValidation()) {
      const newActiveStep =
        isLastStep() && !allStepsCompleted()
          ? stepData.findIndex((step, i) => !(i in completed))
          : activeStep + 1;
      setActiveStep(newActiveStep);
    } else if (activeStep >= 1) {
      setActiveStep(activeStep + 1);
    }
  };

  const backStep = () => {
    setActiveStep(activeStep - 1);
  };

  const dialogHeaderContent = () => {
    return (
     
        <Box marginTop={1} marginRight={3} sx={{ cursor: "pointer" }}>
          <CloseIcon onClick={() => props.handleCloseProfile()} />
        </Box>
      
    );
  };

  const stepperMethod = () => {
    return (
      <>
        <Stepper
          activeStep={activeStep}
          orientation="vertical"
          sx={classes.stepperStyle}
        >
          {stepData.map((label, index) => {
            return (
              <Step
                key={index}
                onClick={() => setActiveStep(index)} // Update activeStep when clicked
                // sx={{ display: "flex", justifyContent: "center" }}
              >
                <StepLabel sx={classes.stepLabel}>
                  <Typography sx={classes.label}>{label}</Typography>
                </StepLabel>
              </Step>
            );
          })}
        </Stepper>
      </>
    );
  };

  const getAllContent = (activeStep: number) => {
    switch (activeStep) {
      case 0:
        return <ViewPersonalinfomation nextStep={nextStep} />;
      case 1:
        return (
          <ViewOfficialInformation nextStep={nextStep} backStep={backStep} />
        );
      case 2:
        return <ViewBankInformation nextStep={nextStep} backStep={backStep} />;
      case 3:
        return (
          <ViewEmployeeDocuments nextStep={nextStep} backStep={backStep} />
        );

      case 4:
        return <ViewLeaveDetails nextStep={nextStep} backStep={backStep} />;
      case 5:
        return <SalaryInformation nextStep={nextStep} backStep={backStep} />;
      default:
        break;
    }
  };

  const dialogTitleContent = () => {
    return (
      <>
        <Box sx={classes.profileWrapper}>
          <Grid container>
            <Grid item xs={3} mt={2}>
              {stepperMethod()}
            </Grid>
            <Grid item xs={7}>
              {getAllContent(activeStep)}
            </Grid>
          </Grid>
        </Box>
      </>
    );
  };

  const getMyProfileView = () => {
    return (
      <CustomDialog
        fullScreen={true}
        isDialogOpen={props.isDialogOpen}
        dialogHeaderContent={dialogHeaderContent()}
        dialogTitleContent={dialogTitleContent()}
        handleDialogClose={props.handleCloseProfile}
      />
    );
  };

  return getMyProfileView();
};

export default MyProfileView;
